import { TreeNodeOrNodeSlug } from 'react-common'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type CustomTreeNode = TreeNodeOrNodeSlug & {
  onClick?: () => void
  badge?: string
}

interface LoadingState {
  backUrl: string
  isAbsolute: boolean
  title: string
  hasCustomScroll: boolean
  isContentMenuOpen: boolean
  lastPageURL: string
  sidebarLayers: null | Array<CustomTreeNode>
}

const initialState: LoadingState = {
  backUrl: '/',
  isAbsolute: false,
  title: '',
  hasCustomScroll: false,
  isContentMenuOpen: false,
  lastPageURL: '',
  sidebarLayers: null,
}

export const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setBackUrl(state, { payload }): void {
      state.backUrl = payload.url
      state.isAbsolute = payload.isAbsolute
    },
    setTitle(state, { payload }: PayloadAction<string>): void {
      state.title = payload
    },
    setHasCustomScroll(state, { payload }: PayloadAction<boolean>): void {
      state.hasCustomScroll = payload
    },
    setContentMenuState(state, { payload }: PayloadAction<boolean>): void {
      state.isContentMenuOpen = payload
    },
    setLastPageURL(state, { payload }: PayloadAction<string>): void {
      state.lastPageURL = payload
    },
    setSidebarLayers(state, action) {
      state.sidebarLayers = action.payload as TreeNodeOrNodeSlug[]
    },
  },
})

export const { setBackUrl, setHasCustomScroll, setContentMenuState, setLastPageURL, setSidebarLayers } =
  layoutSlice.actions

export default layoutSlice.reducer
